(function ($) {

  $('.staff-list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          swipeToSlide: true
        }
      }
    ]
  });

})(jQuery);